module.exports = __webpack_public_path__ + "static/img/address_icon.27ea5ff0.png";